import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import ErrorMessage from '@minecraft.error-message';
import { QUERY_ETHNIC_APPEARANCES } from '../../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FiltersNameEnum } from '../../../shared/types';
import { generateSelectOptionsBasedOnField, getFilteredArrayByEnabled } from '../../../shared/utils';
import { FormItem } from '../../../shared/styles';
import { FilterDrawerType, FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';
import { EthnicAppearance } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const EthnicAppearanceCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_ETHNIC_APPEARANCES);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.ethnicAppearance
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const ethnicAppearanceOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(getFilteredArrayByEnabled(data?.ethnicAppearances), 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.ethnicAppearanceIds],
      true
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (ethnicAppearanceOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.ethnicAppearance]: ethnicAppearanceOptions,
      });
    }
  }, [ethnicAppearanceOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <EthnicAppearance
          name={FiltersNameEnum.ethnicAppearance}
          label={filtersLabelOfAudience[FiltersNameEnum.ethnicAppearance]}
        />
      </FormItem>
    )
  );
};

export default EthnicAppearanceCategory;
